export const ACTIVITY_TYPES = {
  photoActivity: 'photo_activity',
  videoActivity: 'video_activity',
  mealActivity: 'meal_activity',
  bottleActivity: 'bottle_activity',
  moodActivity: 'mood_activity',
  napActivity: 'nap_activity',
  bathroomActivity: 'bathroom_activity',
  incidentActivity: 'incident_activity',
  medicationActivity: 'medication_activity',
  noteActivity: 'note_activity',
  absentActivity: 'absent_activity',
  learningActivity: 'learning_activity',
  nameToFaceActivity: 'name_to_face_activity',
  observationActivity: 'observation_activity',
  signInActivity: 'sign_in_activity',
  signOutActivity: 'sign_out_activity',
  transferActivity: 'transfer_activity'
};

export default [
  { label: 'Nap', id: ACTIVITY_TYPES.napActivity },
  { label: 'Meal', id: ACTIVITY_TYPES.mealActivity },
  { label: 'Notes', id: ACTIVITY_TYPES.noteActivity },
  { label: 'Incident', id: ACTIVITY_TYPES.incidentActivity },
  { label: 'Photo', id: ACTIVITY_TYPES.photoActivity },
  { label: 'Video', id: ACTIVITY_TYPES.videoActivity },
  { label: 'Bottle', id: ACTIVITY_TYPES.bottleActivity },
  { label: 'Mood', id: ACTIVITY_TYPES.moodActivity },
  { label: 'Medication', id: ACTIVITY_TYPES.medicationActivity },
  { label: 'Bathroom', id: ACTIVITY_TYPES.bathroomActivity },
  { label: 'Sign In', id: ACTIVITY_TYPES.signInActivity },
  { label: 'Sign Out', id: ACTIVITY_TYPES.signOutActivity },
  { label: 'Transfer', id: ACTIVITY_TYPES.transferActivity },
  { label: 'Absent', id: ACTIVITY_TYPES.absentActivity },
  { label: 'Learning', id: ACTIVITY_TYPES.learningActivity },
  { label: 'Name To Face', id: ACTIVITY_TYPES.nameToFaceActivity },
  { label: 'Observation', id: ACTIVITY_TYPES.observationActivity }
];

export const APPROVAL_ACTIVITY_TYPES = [
  { label: 'Photo', id: ACTIVITY_TYPES.photoActivity },
  { label: 'Incident', id: ACTIVITY_TYPES.incidentActivity },
  { label: 'Medication', id: ACTIVITY_TYPES.medicationActivity },
  { label: 'Observation', id: ACTIVITY_TYPES.observationActivity },
  { label: 'Absent', id: ACTIVITY_TYPES.absentActivity },
  { label: 'Meal', id: ACTIVITY_TYPES.mealActivity },
  { label: 'Learning', id: ACTIVITY_TYPES.learningActivity },
  { label: 'Bottle', id: ACTIVITY_TYPES.bottleActivity },
  { label: 'Bathroom', id: ACTIVITY_TYPES.bathroomActivity },
  { label: 'Nap', id: ACTIVITY_TYPES.napActivity },
  { label: 'Notes', id: ACTIVITY_TYPES.noteActivity },
  { label: 'Mood', id: ACTIVITY_TYPES.moodActivity },
  { label: 'Video', id: ACTIVITY_TYPES.videoActivity }
];

export const CREATABLE_ACTIVITY_TYPES = [
  { label: 'Nap', id: ACTIVITY_TYPES.napActivity },
  { label: 'Meal', id: ACTIVITY_TYPES.mealActivity },
  { label: 'Notes', id: ACTIVITY_TYPES.noteActivity },
  { label: 'Incident', id: ACTIVITY_TYPES.incidentActivity },
  { label: 'Bottle', id: ACTIVITY_TYPES.bottleActivity },
  { label: 'Photo', id: ACTIVITY_TYPES.photoActivity },
  { label: 'Mood', id: ACTIVITY_TYPES.moodActivity },
  { label: 'Medication', id: ACTIVITY_TYPES.medicationActivity },
  { label: 'Bathroom', id: ACTIVITY_TYPES.bathroomActivity },
  { label: 'Learning', id: ACTIVITY_TYPES.learningActivity },
  { label: 'Name To Face', id: ACTIVITY_TYPES.nameToFaceActivity },
  { label: 'Observation', id: ACTIVITY_TYPES.observationActivity }
];

export const RECURRING_ACTIVITIES = [
  { label: 'Nap', id: ACTIVITY_TYPES.napActivity },
  { label: 'Meal', id: ACTIVITY_TYPES.mealActivity },
  { label: 'Bottle', id: ACTIVITY_TYPES.bottleActivity },
  { label: 'Bathroom', id: ACTIVITY_TYPES.bathroomActivity }
];

export const SIGNABLE_ACTIVITIES = [ACTIVITY_TYPES.incidentActivity];
